









































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { SocialMedia } from "../../services/social-media/entities/social-media.interface";
import rules from "../../utils/rules";

@Component
export default class SocialM extends Vue {
  @Prop() socialMedia!: SocialMedia;
  @Prop() dialogUpdate!: boolean;

  $refs!: {
    formUpdate: HTMLFormElement;
  };

  valid = true;
  loadingUpdate = false;
  snackbarSuccessUpdate = false;
  snackbarErrorUpdate = false;
  url = this.socialMedia.socialMediaURL;
  status = this.socialMedia.socialMediaStatus;
  icon = this.socialMedia.socialMediaIcon;
  name = this.socialMedia.socialMediaName;
  generalRules = [rules.notEmpty];

  private cancelUpdate(): void {
    this.$emit("cancelUpdate");
  }

  private updateSocialMedia(): void {
    this.loadingUpdate = true;
    this.$store
      .dispatch("socialMedia/updateSocialMedia", {
        socialMediaId: this.socialMedia.socialMediaID,
        status: this.status,
        url: this.url,
        socialMediaName: this.name,
        socialMediaIcon: this.icon
      })
      .then((response: any) => {
        if (response) {
          this.snackbarSuccessUpdate = true;
        } else {
          this.snackbarErrorUpdate = true;
        }
      })
      .finally(() => {
        this.loadingUpdate = false;
        this.$emit("cancelUpdate");
      });
  }

  private get allStatus(): Array<string> {
    return this.$store.getters["common/getStatus"];
  }

  private openMaterialDesignIcons(): void {
    window.open(process.env.VUE_APP_MATERIAL_DESIGN_ICON);
  }
}
